export default __webpack_public_path__ + "static/media/arrow-in-create-block.bdfd40f0.svg";